import React from "react";

import "./reminder-card.scss";

const ReminderCard = ({ mobile }) => {

    const classImgByCountry = process.env.LOCALE === 'es-PE' ?
        'f-img-PE'
        :
        process.env.LOCALE === 'es-EC' ?
            'f-img-EC'
            :
            process.env.LOCALE === 'es-UY' ?
                'f-img-UY'
                :
                process.env.LOCALE === 'es-PY' ?
                'f-img-PY'
                :
                    process.env.LOCALE === 'es-CL' ?
                    'f-img-CL'
                    :
                    ''

    return (
        <div className="f-reminder-card">
            <div className={"f-image-reminder-card " + classImgByCountry} />
            <div className="f-reminder-card-info-container">
                <div className="f-reminder-card-info-container-description">
                    <p>
                        Recuerda que debes guardar todos los empaques que ingreses, así,
                        cerraremos correctamente el ciclo de nuestros empaques y ayudaremos a cuidar el planeta.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ReminderCard;